
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("b7L2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $8194d6fc404705fb$var$_jquery = $8194d6fc404705fb$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $8194d6fc404705fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $8194d6fc404705fb$var$init = module.exports.init = function init() {
    (0, $8194d6fc404705fb$var$_jquery["default"])(".scrollto").on("click", function(e) {
        e.preventDefault();
        var href = (0, $8194d6fc404705fb$var$_jquery["default"])(this).attr("href");
        (0, $8194d6fc404705fb$var$_jquery["default"])("html, body").stop().animate({
            scrollTop: (0, $8194d6fc404705fb$var$_jquery["default"])(href).offset().top - 50
        }, 1000);
    });
};

});


//# sourceMappingURL=scrollTo.module.1b0ad644.js.map
